var map = {
	"./BigEventStorming.vue": "1030",
	"./BusinessModelCanvas.vue": "8979",
	"./BusinessModelPanel.vue": "4c33",
	"./elements/BusinessModelElement.vue": "4f54",
	"./elements/BusinessModelPerspective.vue": "8d3e",
	"./elements/BusinessModelTooltip.vue": "50f3",
	"./elements/BusinessRelation.vue": "6f1e",
	"./elements/BusinessSubController.vue": "4447",
	"./elements/Channel.vue": "7940",
	"./elements/CostStructure.vue": "6278",
	"./elements/CustomerRelationship.vue": "218a",
	"./elements/CustomerSegment.vue": "2cea",
	"./elements/KeyActivity.vue": "1842",
	"./elements/KeyResource.vue": "117c",
	"./elements/RevenueStream.vue": "a9de",
	"./elements/ValueProposition.vue": "a98a",
	"./elements/keyPartner.vue": "bc7d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "130e";